models.service('TransactionHistoryModel', [
    '$filter', 'constants', 'Utils',
    function ($filter, Const, Utils) {

        function Transaction(data) {
            var self = this;

            self.amount = data.amount;
            self.bankAcccountNumberLast4Digits = data.bankAcccountNumberLast4Digits;
            self.bankName = data.bankName;
            self.confirmDate = parseInt(parseInt(data.confirmDate, 10) * 1000, 10);
            self.creditCardLast4Digits = data.creditCardLast4Digits;
            self.creditcardType = data.creditcardType;
            self.method = data.method && Utils.toCamelCase(data.method.toString());
            self.requestDate = parseInt(parseInt(data.requestDate, 10) * 1000, 10);
            self.type = data.type;
            self.live = Utils.toBoolean(data.live);
            self.login = data.login;
            self.currency = data.currency;
            self.transactionId = data.transactionId;
            self.fromTradingAccount = data.fromMt4AccountId > 0 ? data.fromMt4AccountId : null;
            self.toTradingAccount = data.toMt4AccountId > 0 ? data.toMt4AccountId : null;


            self.clear = function () {
            }
        }

        return Transaction;

    }]);